$(document).ready(function () {
    if ($('div.small-fleets-logo-container').length > 0) {
        $("#product-form").submit(function (e) {

            var total_quantity_selected = 0;
            var elements = document.getElementsByClassName("product-amount");

            for (var i = 0; i < elements.length; i++) {
                total_quantity_selected += parseInt(elements[i].value);
            }

            if (!parseInt($("input[name='quant-VG34']").val()) &&
                !parseInt($("input[name='quant-CM31']").val()) &&
                !parseInt($("input[name='quant-CM32']").val())) {
                    $(this).attr('action', "/express/shipping");                
            }
                         
            if (total_quantity_selected > 0) {
                $("#continue-to-shipping").attr("disabled", true);
                return true;
            } else {
                alert('Please add products before continuing to checkout.');
                return false;
            }

        });
    }
});

if ($('div.small-fleets-logo-container').length > 0) {
    $('.webstore-button').click(function(e){
        e.preventDefault();
        
        var fieldName = $(this).attr('data-field');
        var type      = $(this).attr('data-type');
        var input = $("input[name='"+fieldName+"']");
        var currentVal = parseInt(input.val());
        var minValue =  parseInt($(input).attr('min'));
        var maxValue =  parseInt($(input).attr('max'));

        if (!isNaN(currentVal)) {
            if (type == 'minus') {
                    
                if (currentVal >= minValue) {
                    input.val(currentVal - 1).change();
                } 

                if (parseInt(input.val()) == minValue) {
                    $(this).attr('disabled', true);
                }

            } else if (type == 'plus') {

                if (currentVal <= maxValue) {
                    input.val(currentVal + 1).change();
                }

                if (parseInt(input.val()) == maxValue) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
        }

        var valueCurrent = parseInt($(input).val());
        var name = $(input).attr('name');

        if(valueCurrent >= minValue) {
            $(".webstore-button[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
        } else {
            $(input).val(parseInt(input.val()) + 1);
        }
        if(valueCurrent <= maxValue) {
            $(".webstore-button[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
        } else {
            alert("You cannot buy more than 2 of any product through this checkout. If you would like to purchase more, email smallfleets@samsara.com");
            $(input).val(parseInt(input.val()) - 1);
        }
    });

    $('.product-amount').focusin(function(){
        $(this).data('oldValue', $(this).val());
    });

    $('.product-amount').change(function() {
        

        var minValue =  parseInt($(this).attr('min'));
        var maxValue =  parseInt($(this).attr('max'));
        var valueCurrent = parseInt($(this).val());
        var name = $(this).attr('name');
        
        if(valueCurrent >= minValue) {
            $(".webstore-button[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
        } else {
            $(this).val(minValue);
        }
        if(valueCurrent <= maxValue) {
            $(".webstore-button[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
        } else {
            alert("You cannot buy more than 2 of any product through this checkout. If you would like to purchase more, email sales@samsara.com");
            $(this).val(maxValue);
        }	
            
    });

    $(".product-amount").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });
}